import styled, { css } from 'styled-components';
import { APriceSize, type APriceProps } from './APrice.types';
type StyleProps = Omit<APriceProps, 'value'>;

const stylesBySize = ({ size = APriceSize.Small }: StyleProps) => {
  return {
    Large: css`
      font-size: 1.375rem;
    `,
    Small: css`
      font-size: 0.875rem;
    `,
  }[size];
};

export const Wrapper = styled.div<StyleProps>`
  font-family: var(--t-base-font-family);
  color: var(--t-brand-fg-color);
  font-style: normal;
  font-weight: 700;
  line-height: 100%;
  ${stylesBySize}
`;
